.filter-wrapper{max-width:100%}.filter-wrapper .dropdown-toggle.active{color:#5930fb;border-color:#5930fb}.input{width:300px}
/*# sourceMappingURL=scheduler-reports-search.component-3UVNYFBZ.css.map */
